export default __webpack_public_path__ + "59fd7ef2c3421ff67c48efce07bd1226.jpg";